export const checkoutLinkFor = ({ origin, productId }) => ({
  url: `${origin}/buy/${productId}`,
  productId,
});

export const canCreateLink = ({ isCustomImageUpload }) => !isCustomImageUpload;

const WARNING_FOR = {
  vaulted:
    "This product is vaulted, so the link won't add it to the cart until it's back in the shop.",
  hidden:
    "This product is hidden, so the link won't add it to the cart until it's visible again.",
  soldOut:
    "This product is sold out, so the link won't add it to the cart until it's back in stock.",
};

const unavailableReason = ({ isActive, vaultedUntil, isSoldOut }) =>
  vaultedUntil
    ? "vaulted"
    : !isActive
    ? "hidden"
    : isSoldOut
    ? "soldOut"
    : null;

export const linkWarningFor = (product) =>
  WARNING_FOR[unavailableReason(product)] ?? null;

const slugFor = (text) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const qrFileNameFor = ({ name, productId }) =>
  `${slugFor(name) || productId}-checkout-qr.png`;
